import UserNewContainer from './UserNew.container';

export default UserNewContainer;
